import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import {Helmet} from "react-helmet";

const General = ()=>{
    return(
        <div className='general-wrap'>
            <Helmet>
                <title>آموزش های عمومی بل میت</title>
                <meta name="description" content="در این بخش آموزش های عمومی ویژه وب کنفرانس ها و کلاس های آنلاین و رویدادهای آنلاین را می توانید مشاهده کنید." />
            </Helmet>
            <div className='general-dec'>
                <Nav/>
                <h1>آموزش های عمومی</h1>
                <br/>
                <p>برای دیدن آموزش های عمومی به <a href="https://blog.bellmeet.com">بلاگ BellMeet</a> مراجعه کنید.</p>
                <Footer/>
            </div>
        </div>
    )
}

export default General